<template>
    <!-- <span :key="iitem + 'tooltip-span'" :name="iitem + 'tooltip-span-name'"
                                :id="iitem + 'tooltip-span-id'">
                                <a href="#" :key="iitem + 'tooltip-href'"
                                    class="text-decoration-none footer-link-hover">{{item.subCategory}}</a>
                                
                            </span> -->
    <v-tooltip :key="Id + 'tooltip'" :name="Id + 'tooltip-name'" :id="Id + 'tooltip-id'" open-on-hover>
        <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" :key="Id + 'tooltip-span'" :name="Id + 'tooltip-span-name'"
                :id="Id + 'tooltip-span-id'" v-on="on">
                <a href="#" :key="Id + 'tooltip-href'" class="text-decoration-none footer-link-hover">{{Title}}</a>
            </span>
        </template>
        <span :key="Id + 'tooltip-span-label'" :name="Id + 'tooltip-span-label-name'"
            :id="Id + 'tooltip-span-label-id'">{{Content}}</span>

    </v-tooltip>
  
</template>


<script>
export default {
    props: {
        Title: {
            type: String,
            required: true
        },
        Content: {
            type: String,
            required: true
        },
        Id: {
            type: Number,
            requierd: true
        }
    }
}
</script>